import { useState, useRef } from "react";

export const useWordCloudChart = (title) => {
    const chartRef = useRef(null);

    const [options, setOptions] = useState({
        chart: {
            events: {
                load: function () {
                    chartRef.current = this;
                },
            },
        },
        series: [
            {
                type: "wordcloud",
                data: [],
                name: "Occurrences",
                animation: true, // Avoid crash on initial load
            },
        ],
        title: {
            text: "",
        },
        tooltip: {
            headerFormat: '<span style="font-size: 16px"><b>{point.key}</b></span><br/>',
            pointFormat: "Ocurrencias: {point.weight}",
        },
        lang: {
            viewFullscreen: "Ver en pantalla completa",
            loading: "Cargando...",
            noData: "No hay datos para mostrar",
        },
        exporting: {
            enabled: false,
            buttons: {
                contextButton: {
                    menuItems: ["viewFullscreen"],
                },
            },
        },
        credits: { enabled: false },
    });

    const showLoading = () => chartRef.current?.showLoading();
    const hideLoading = () => chartRef.current?.hideLoading();

    const onChartReady = (chartInstance) => {
        chartRef.current = chartInstance;
    };

    return {
        options,
        setOptions,
        showLoading,
        hideLoading,
        onChartReady,
    };
};
